import { render, staticRenderFns } from "./fixing.vue?vue&type=template&id=13aeb744&"
import script from "./fixing.vue?vue&type=script&lang=ts&"
export * from "./fixing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports